(() => {
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  document.querySelectorAll('[data-recipe-finder]').forEach(async root => {
    const form = root.querySelector('[data-recipe-search]');
    const input = form.querySelector('input[type="search"]');
    const results = root.querySelector('[data-recipe-results]');
    const status = root.querySelector('[data-recipe-status]');
    const sort = root.querySelector('[data-recipe-sort]');
    const clear = root.querySelector('[data-recipe-clear]');
    const options = root.querySelector('[data-recipe-options]');
    const labels = JSON.parse(root.querySelector('[data-recipe-labels]').textContent);
    const categoryLinks = [...root.querySelectorAll('.nr-category-list a')];
    const base = root.dataset.blogUrl;
    const size = Number(root.dataset.pageSize) || 12;
    let recipes = [];
    let state;
    const readState = () => {
      const url = new URL(location.href);
      return { q: url.searchParams.get('recipe_q') || '', sort: url.searchParams.get('recipe_sort') || 'newest', page: Math.max(1, Number(url.searchParams.get('page')) || 1), course: decodeURIComponent(url.pathname.split('/tagged/')[1] || '') };
    };
    const linkCourse = link => new URL(link.href).pathname.split('/tagged/')[1] || '';
    const courseLink = () => categoryLinks.find(link => linkCourse(link) === state.course);
    const updateURL = (replace = false) => {
      const url = new URL(location.href);
      url.pathname = state.course ? `${base}/tagged/${state.course}` : base;
      [['recipe_q', state.q], ['recipe_sort', state.sort === 'newest' ? '' : state.sort], ['page', state.page > 1 ? String(state.page) : '']].forEach(([key,value]) => value ? url.searchParams.set(key,value) : url.searchParams.delete(key));
      url.hash = '';
      history[replace ? 'replaceState' : 'pushState']({}, '', url);
    };
    const card = (recipe, index) => {
      const article = make('article','nr-recipe');
      const link = make('a','nr-recipe__link');
      link.href = recipe.url;
      if (recipe.image) {
        const media = make('div','nr-recipe__media');
        const img = make('img','nr-recipe__image');
        const imageURL = new URL(recipe.image.url, location.origin);
        img.src = imageURL.href;
        img.srcset = [360,540,720].map(width => { const url = new URL(imageURL); url.searchParams.set('width',String(width)); return `${url.href} ${width}w`; }).join(', ');
        img.sizes = '(min-width: 1248px) 379px, (min-width: 1000px) calc((100vw - 112px) / 3), (min-width: 641px) calc((100vw - 76px) / 2), calc(100vw - 32px)';
        img.alt = recipe.image.alt || recipe.title;
        img.width = recipe.image.width;
        img.height = recipe.image.height;
        img.loading = index < 3 ? 'eager' : 'lazy';
        img.decoding = 'async';
        media.append(img); link.append(media);
      }
      const body = make('div','nr-recipe__body');
      body.append(make('h3','',recipe.title),make('span','nr-recipe__read',labels.read));
      link.append(body); article.append(link); return article;
    };
    const render = (focus = false) => {
      const tokens = normalize(state.q).trim().split(/\s+/).filter(Boolean);
      const selected = recipes.filter(recipe => (!state.course || recipe.courses.includes(state.course)) && tokens.every(token => recipe.searchText.includes(token)));
      selected.sort((a,b) => state.sort === 'title' ? a.title.localeCompare(b.title) : state.sort === 'oldest' ? Number(a.published)-Number(b.published) : Number(b.published)-Number(a.published));
      const pages = Math.max(1, Math.ceil(selected.length / size));
      const requestedPage = state.page;
      state.page = Math.min(state.page, pages);
      if (state.page !== requestedPage) updateURL(true);
      input.value = state.q; sort.value = state.sort;
      categoryLinks.forEach(link => linkCourse(link) === state.course ? link.setAttribute('aria-current','page') : link.removeAttribute('aria-current'));
      const fragment = document.createDocumentFragment();
      const heading = make('div','nr-results__heading');
      const h2 = make('h2','', courseLink()?.textContent.trim() || (state.course ? labels.filtered : labels.browse));
      h2.tabIndex = -1;
      heading.append(h2);
      const first = (state.page-1)*size;
      const count = make('p','nr-results__count',selected.length ? labels.range.replace('__FIRST__',first+1).replace('__LAST__',Math.min(first+size,selected.length)).replace('__TOTAL__',selected.length) : labels.zero);
      status.textContent = [h2.textContent, state.q ? labels.search + ': ' + state.q : '', sort.selectedOptions[0].textContent, count.textContent].filter(Boolean).join('. ');
      heading.append(count); fragment.append(heading);
      if (selected.length) {
        const grid = make('div','nr-grid');
        selected.slice(first,first+size).forEach((recipe,index) => grid.append(card(recipe,index)));
        fragment.append(grid);
      } else {
        const empty = make('div','nr-empty'); empty.append(make('p','',labels.empty)); fragment.append(empty);
      }
      if (pages > 1) {
        const nav = make('nav','nr-pagination'); nav.setAttribute('aria-label',labels.pages);
        const prev = make('button','nr-pagination__direction',labels.previous);
        prev.type = 'button'; prev.disabled = state.page === 1;
        prev.addEventListener('click',() => { state.page--; updateURL(); render(true); });
        const pageText = make('span','',`${state.page} / ${pages}`);
        const next = make('button','nr-pagination__direction',labels.next);
        next.type = 'button'; next.disabled = state.page === pages;
        next.addEventListener('click',() => { state.page++; updateURL(); render(true); });
        nav.append(prev,pageText,next); fragment.append(nav);
      }
      results.replaceChildren(fragment);
      clear.disabled = !state.q && !state.course && state.sort === 'newest';
      if (focus) { h2.focus({preventScroll:true}); results.scrollIntoView({block:'start',behavior:'auto'}); }
    };
    try {
      let next = root.dataset.indexUrl;
      const seen = new Set();
      while (next) {
        const url = new URL(next, location.origin);
        const current = new URL(location.href);
        if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
        url.searchParams.set('view','recipe-index');
        if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid recipe index');
        seen.add(url.href);
        const response = await fetch(url.href,{credentials:'same-origin'});
        if (!response.ok) throw new Error('Recipe index unavailable');
        const data = await response.json();
        if (!Array.isArray(data.recipes)) throw new Error('Invalid recipe data');
        recipes.push(...data.recipes);
        next = data.next;
        if (!next && recipes.length !== data.total) throw new Error('Incomplete recipe index');
      }
      recipes = recipes.map(recipe => ({...recipe,courses:recipe.courses,searchText:normalize([recipe.title,recipe.tags.join(' '),recipe.search].join(' '))}));
      state = readState();
      form.querySelector('label').textContent = labels.search;
      form.querySelector('p').textContent = labels.help;
      input.placeholder = labels.placeholder; input.required = false;
      form.addEventListener('submit', event => { event.preventDefault(); state.q = input.value.trim(); state.page = 1; updateURL(); render(true); });
      sort.addEventListener('change',() => { state.sort = sort.value; state.page = 1; updateURL(); render(); });
      clear.addEventListener('click',() => { state = {q:'',course:'',sort:'newest',page:1}; updateURL(); render(); input.focus(); });
      categoryLinks.forEach(link => link.addEventListener('click',event => {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); state.course = linkCourse(link); state.page = 1; updateURL(); render();
      }));
      window.addEventListener('popstate',() => {state = readState(); render();});
      options.hidden = false;
      root.dataset.finderReady = 'true';
      render();
    } catch (error) {
      root.dataset.finderReady = 'false';
    }
  });
})();
